import React from 'react'
import { Trash2 } from 'lucide-react'
import { cn } from '../../../utils/classnames'

const DeleteIconButton = ({ onClick, className = '', disabled = false }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'p-3 h-custom50 w-custom50 rounded-xl text-sm font-semibold transition duration-200 items-center flex gap-2 justify-center',
        'hover:opacity-80 disabled:opacity-50 border-redDeep bg-redSoft border-r-2 border-b-2',
        className
      )}
    >
      <Trash2 size={20} className="text-white" strokeWidth={2} />
    </button>
  )
}

export default DeleteIconButton
